/*
 * 初始化极验验证码
 *    高阶组件
 * */
import { PureComponent } from 'react';
import HTTP from '../../script/service';
import Util from '../../script/util';
import { _anly_seng_custom } from '../../store/Action';

const jxCaptchaVerifiedHOC = (WrapComponent) => {
  return class Component extends PureComponent {
    state = {
      geeType: 2, // 初始化极验后端所需要的参数
      historyOptions: null, // 缓存 options 改变则需要重新初始化极验
    };

    // 获取验证码初始化的实例
    getCaptchaInstance = () => {
      return this.captchaInstance;
    };
    /**
     * @description 初始化验证码
     * @param {{phone: number, nationCode:number, geeType?: number, bizType:? number}} options
     * @param {() => void | null} successCallback       //成功回调
     * @param {() => void | null} closeCallback         //关闭回调
     * @returns void
     */
    initCaptchaVerified = (
      options,
      successCallback = null,
      closeCallback = null
    ) => {
      if (this?.captchaInstance?.getValidate()) {
        // 已完成验证
        if (successCallback) {
          successCallback();
        }
      } else if (this.captchaInstance) {
        const { historyOptions, geeType } = this.state;
        const { nationCode, phone, geeType: type, bizType } = options;
        if (
          historyOptions.nationCode != nationCode ||
          historyOptions.phone != phone ||
          geeType != type ||
          historyOptions.bizType != bizType
        ) {
          this.setState(
            { historyOptions: options, geeType: type },
            async () => {
              this.destroyCaptchaVerified();
              await Util.sleep(300);
              this.initCaptchaVerified(options, successCallback);
            }
          );
        } else {
          this.captchaInstance.verify();
        }
      } else {
        const { geeType } = this.state;
        const { nationCode, phone, geeType: type, bizType } = options;
        const params = { geeType };
        if (type != null) {
          params.geeType = type;
          this.setState({ geeType: type });
        }
        params.bizType = bizType == null ? 0 : bizType;
        if (!options?.isGlobal) {
          const { rootConfig } = this.props.base;
          if (bizType == null) {
            params.bizId =
              (rootConfig.lang !== 'zh_CN' ? nationCode : '') + phone;
          }
        }
        this.setState({ historyOptions: options });
        HTTP._get_register_geetest(params).then((res) => {
          if (res?.code === 200) {
            const { data } = res;
            window.initGeetest(
              {
                gt: data.gt,
                challenge: data.challenge,
                new_captcha: data.new_captcha, // 用于宕机时表示是新验证码的宕机
                offline: !data.success, // 表示用户后台检测极验服务器是否宕机，一般不需要关注
                product: 'bind', // 产品形式，包括：float，popup
                width: '100%',
              },
              (captchaObj) => {
                this.captchaInstance = captchaObj;
                this.captchaInstance.onReady(() => {
                  this.captchaInstance.verify();
                });
                this.captchaInstance.onError((error) => {
                  console.error('get captcha error: ', error);
                  _anly_seng_custom(2000, { data: error });
                });
                this.captchaInstance.onClose(() => {
                  closeCallback && closeCallback();
                  this.resetCaptchaVerified();
                });

                // 验证完成
                if (successCallback) {
                  this.captchaInstance.onSuccess(successCallback);
                }
              }
            );
          } else if (res?.code === 5500) {
            // 需要调整geeType
            this.setState({ geeType: res.data.geeType }, () => {
              this.initCaptchaVerified(
                { ...options, geeType: this.state.geeType },
                successCallback
              );
            });
          }
        });
      }
    };

    // 获取验证码数据
    getCaptchaVerified = () => {
      const value = this.captchaInstance?.getValidate() ?? null;
      if (value) {
        value.geeType = this.state.geeType;
      }
      return value;
    };

    // 重置验证码
    resetCaptchaVerified = () => {
      this.captchaInstance && this.captchaInstance.reset();
    };

    // 销毁验证码
    destroyCaptchaVerified = () => {
      this.captchaInstance && this.captchaInstance.destroy();
      this.captchaInstance = null;
    };

    render() {
      return (
        <WrapComponent
          {...this.props}
          getCaptchaInstance={this.getCaptchaInstance}
          initCaptchaVerified={this.initCaptchaVerified}
          resetCaptchaVerified={this.resetCaptchaVerified}
          getCaptchaVerified={this.getCaptchaVerified}
          destroyCaptchaVerified={this.destroyCaptchaVerified}
        />
      );
    }
  };
};
export default jxCaptchaVerifiedHOC;
